import { useCallback, useSyncExternalStore } from "react";
import { NONE } from "../util/constants.js";
import { BLACKHOLE } from "../util/function.js";
import { runSequence } from "../util/sequence.js";
export function useStore(store) {
    useSyncExternalStore(useCallback(onStoreChange => (store ? runSequence(store, onStoreChange, onStoreChange) : BLACKHOLE), [store]), () => (!store ? store : store.loading ? NONE : store.value));
    return store ?? undefined;
}
